import { useTheme } from '@emotion/react';
import { Drawer, IconButton, Modal, Paper, useMediaQuery } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

import { ReactComponent as CloseIcon } from 'src/assets/svg/close-icon.svg';

import { styles } from './styles';

type LoginWrapperProps = {
    open: boolean;
    onClose: () => void;
};

export const LoginWrapper: FC<PropsWithChildren<LoginWrapperProps>> = ({
    children,
    open,
    onClose,
}) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    if (isSmallScreen)
        return (
            <Drawer anchor="bottom" open={open} css={styles.loginDialogDrawer} keepMounted={false}>
                {children}

                <IconButton
                    css={styles.loginDialogCloseButton}
                    onClick={onClose}
                    id="login-drawer-close"
                >
                    <CloseIcon />
                </IconButton>
            </Drawer>
        );

    return (
        <Modal open={open} css={styles.loginDialogModal} keepMounted={false}>
            <Paper variant="outlined" css={styles.loginDialogPaper}>
                {children}

                <IconButton
                    css={styles.loginDialogCloseButton}
                    onClick={onClose}
                    id="login-modal-close"
                >
                    <CloseIcon />
                </IconButton>
            </Paper>
        </Modal>
    );
};
